// extracted by mini-css-extract-plugin
export var actionButton = "_eh-t";
export var buttonContainer = "_eh-0";
export var buttonContainer2 = "_eh-1";
export var buttonSection = "_eh-2";
export var details = "_eh-3";
export var dropdownItem = "_eh-5";
export var dropdownItemsContainer = "_eh-4";
export var fileInput = "_eh-r";
export var headerButton = "_eh-6";
export var icon = "_eh-7";
export var input = "_eh-8";
export var macroListItem = "_eh-9";
export var mainContent = "_eh-a";
export var microText = "_eh-b";
export var modal = "_eh-w";
export var optionsButton = "_eh-c";
export var paperclip = "_eh-s";
export var pillContent = "_eh-d";
export var preview = "_eh-e";
export var preview2 = "_eh-f";
export var quillEditor = "_eh-q";
export var selectedMacro = "_eh-g";
export var sidebar = "_eh-h";
export var sidebarHeader = "_eh-j";
export var sidebarList = "_eh-i";
export var sidebarListItem = "_eh-k";
export var sidebarSearch = "_eh-l";
export var snoozeDurationWrapper = "_eh-v";
export var statusPillContainer = "_eh-m";
export var tagsContainer = "_eh-n";
export var unselectedMacro = "_eh-o";
export var variable = "_eh-u";
export var wrapper = "_eh-p";